module.exports = __webpack_public_path__ + "img/gen_thumb.d044fcd5.png";